// Lazy PostHog loader — keeps ~300KB of posthog-js out of the initial bundle.
//
// The library is fetched on first use (or via initPostHog() scheduled after
// first paint). Events fired before loading finishes are queued on the shared
// promise and flushed in order once init completes, so callers stay
// fire-and-forget and analytics can never break or block the app.

let loadPromise = null;

export function initPostHog() {
  if (loadPromise) return loadPromise;
  loadPromise = (async () => {
    try {
      const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
      if (!apiKey) return null;
      const { default: posthog } = await import('posthog-js');
      posthog.init(apiKey, {
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://app.posthog.com',
      });
      return posthog;
    } catch (error) {
      console.warn('PostHog failed to load, analytics disabled:', error?.message || error);
      return null;
    }
  })();
  return loadPromise;
}

export async function capturePostHog(eventName, properties = {}) {
  if (typeof window === 'undefined') return;
  try {
    const posthog = await initPostHog();
    posthog?.capture(eventName, properties);
  } catch {
    // Analytics must never break the app.
  }
}

export async function identifyPostHog(userId, properties = {}) {
  if (typeof window === 'undefined') return;
  try {
    const posthog = await initPostHog();
    posthog?.identify(userId, properties);
  } catch {
    // Analytics must never break the app.
  }
}
